import { Link } from "react-router-dom";
import type { Tag } from "@shared/types";

export function TagPill({ tag, linked = true, showCount = false }: { tag: Tag; linked?: boolean; showCount?: boolean }) {
  const cls = tag.type === "style_direction" ? "tag-pill style"
    : tag.type === "primary_category" || tag.type === "secondary_category" ? "tag-pill category"
    : "tag-pill";
  const content = (
    <>
      <span>{tag.name}</span>
      {showCount && tag.brandCount != null ? <span className="tag-pill__count">{tag.brandCount}</span> : null}
    </>
  );

  if (!linked) return <span className={cls}>{content}</span>;

  const href = tag.type === "primary_category" || tag.type === "secondary_category"
    ? `/categories/${tag.slug}`
    : `/tags/${tag.slug}`;
  return <Link to={href} className={cls}>{content}</Link>;
}
